import { render, staticRenderFns } from "./gantt-leaf.vue?vue&type=template&id=d5c35dc6&scoped=true&"
import script from "./gantt-leaf.vue?vue&type=script&lang=ts&"
export * from "./gantt-leaf.vue?vue&type=script&lang=ts&"
import style0 from "./gantt-leaf.vue?vue&type=style&index=0&id=d5c35dc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c35dc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bogo\\we-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5c35dc6')) {
      api.createRecord('d5c35dc6', component.options)
    } else {
      api.reload('d5c35dc6', component.options)
    }
    module.hot.accept("./gantt-leaf.vue?vue&type=template&id=d5c35dc6&scoped=true&", function () {
      api.rerender('d5c35dc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/gantt/components/gantt-leaf.vue"
export default component.exports